module.exports = __webpack_public_path__ + "static/img/he10.049b36a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/he10.png
// module id = n1RH
// module chunks = 1